import type { Breakpoint } from '@/global/types'

import { useState, useEffect } from 'react'

import { breakpoints } from '@/global/constants/breakpoints'

export function useBreakpoint(matcher?: Breakpoint): boolean | Breakpoint {
  const [currentBreakpoint, setCurrentBreakpoint] =
    useState<Breakpoint>('unknown')

  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== 'undefined') {
        const matchedBreakpoint = Object.keys(breakpoints)
          .reverse()
          .find(
            key => window.matchMedia(breakpoints[key as Breakpoint]).matches
          ) as Breakpoint

        setCurrentBreakpoint(matchedBreakpoint ?? 'unknown')
      }
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  if (matcher) {
    return (currentBreakpoint === matcher) as boolean
  }

  return currentBreakpoint as Breakpoint
}
